import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useMediaQuery, makeStyles } from '@material-ui/core'
import { MenuItemLink, usePermissions } from 'react-admin'
import { withRouter } from 'react-router-dom'
import BookmarkIcon from '@material-ui/icons/Bookmark'
import AppsIcon from '@material-ui/icons/Apps'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { List, ListItem, ListItemText, Collapse, CircularProgress } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  menuItem: {
    '& .MuiListItemText-primary': {
      fontSize: '16px'
    },
    '& span': {
      fontSize: '16px'
    }
  }
}))

const Menu = ({ onMenuClick, logout }) => {
  const classes = useStyles()
  const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'))
  const open = useSelector(state => state.admin.ui.sidebarOpen)
  const [zicsaOpen, setZicsaOpen] = useState(true)
  const [adminOpen, setAdminOpen] = useState(true)
  const { permissions } = usePermissions()

  if (!permissions) {
    return (
      <div style={{ marginTop: '1em' }}>
        <List component="nav">
          <ListItem>
            <CircularProgress />
          </ListItem>
        </List>
      </div>
    )
  }

  return (
    <div style={{ marginTop: '1em' }}>
      <List component="nav" style={{ backgroundColor: 'white' }}>
        <ListItem>
          <MenuItemLink
            to="/"
            primaryText="Inicio"
            className={classes.menuItem}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
        </ListItem>
        {
          (permissions['zicsa'] || false) && (
            <React.Fragment>
              <ListItem button onClick={() => setZicsaOpen(!zicsaOpen)} selected={zicsaOpen}>
                <ListItemText inset primary="Docuclass" />
                {zicsaOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={zicsaOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {
                    (permissions['zicsa/purchase_orders'] || false) && (
                      <MenuItemLink
                        to="/zicsa/purchase_orders"
                        primaryText="Ordenes de compra"
                        className={classes.menuItem}
                        leftIcon={<BookmarkIcon fontSize="medium" />}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                      />
                    )
                  }
                  {
                    (permissions['zicsa/invoices'] || false) && (
                      <MenuItemLink
                        to="/zicsa/invoices"
                        primaryText="Notas de ingreso"
                        className={classes.menuItem}
                        leftIcon={<BookmarkIcon fontSize="medium" />}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                      />
                    )
                  }
                  {
                    (permissions['zicsa/status_invoices'] || false) && (
                      <MenuItemLink
                        to="/zicsa/status_invoices"
                        primaryText="Estados Facturas"
                        className={classes.menuItem}
                        leftIcon={<BookmarkIcon fontSize="medium" />}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                      />
                    )
                  }
                 {
                    (permissions['zicsa/invoices_journal'] || false) && (
                      <MenuItemLink
                        to="/zicsa/preinvoices"
                        primaryText="Registro pre-facturas"
                        className={classes.menuItem}
                        leftIcon={<BookmarkIcon fontSize="medium" />}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                      />
                    )
                  }
                </List>
              </Collapse>
            </React.Fragment>
          )
        }
        {
          (permissions['admin'] || false) && (
            <React.Fragment>
              <ListItem button onClick={() => setAdminOpen(!adminOpen)} selected={adminOpen}>
                <ListItemText inset primary="Administracion" />
                {adminOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={adminOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {
                    (permissions['admin/staff'] || false) && (
                      <MenuItemLink
                        to="/admin/staff"
                        primaryText="Usuarios"
                        className={classes.menuItem}
                        leftIcon={<AppsIcon fontSize="medium" />}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                      />
                    )
                  }
                </List>
              </Collapse>
            </React.Fragment>
          )
        }
      </List>
      {isXSmall && logout}
    </div>
  )
}

export default withRouter(Menu)